<!-- <img sr"../../../../assets/images/merchantReport.pngc=" alt="" width="100%" height="100%"> -->
<div class="card pt-0 mb-5 ">
  <div class="card-header">
      <h4>Merchant Report</h4>
    </div>
  <div class="card-body">
    <form (ngSubmit)="onSubmit(orvreport.value)" [formGroup]="orvreport">
      <div>
        <div class="row hidden">
          <div class="col-sm-4">
              <label class="form-label">Merchant Name <span aria-hidden="true" class="symbol required" style="color:red;">*</span> </label>
              <ng-select formControlName="merchantId" (change)="onSelectMerchant($event)"
                placeholder="Merchant Name">
                <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.MerchantId">
                  {{merchant.merchant_name}} ({{merchant.MerchantId}})
                </ng-option>
              </ng-select>
              <div *ngIf="!mindatadis" class="text-danger mt-1">
               No Report Found !
              </div>
          </div>
          <!-- <div class="col-sm-2">
         
            <button class="btn btn-sm btn-primary mt-4"  type="submit" >Download </button>
            <div  *ngIf="loading" >  
                    <div class="spinner-border" role="status">
                      <span class="sr-only"></span>
                    </div>
            </div>
          </div> -->
         </div>
     
            </div>
     
      </form>

  

  <div class="box" *ngIf="showhtml">


            <div class="row mt-4">
             
              <div class="col-lg-5 col-sm-12">
                <span style="text-align: center;"><strong>API Engine Response</strong></span>
                <div class="h-100">
                    <ul>
                        <li class="m-4"><span class="w-75 d-inline-block">PAN </span><button (click)="retryPanGstinMca()" class={{btnpan}}>{{btnvaluepan}}</button></li>
                        <li class="m-4"><span class="w-75 d-inline-block">GSTIN </span><button (click)="retryPanGstinMca()"  class={{btngst}}>{{btnvaluegstn}}</button> </li>
                        <li class="m-4"><span class="w-75 d-inline-block">MCA </span><button (click)="retryPanGstinMca()"  class={{btnmca}}>{{btnvaluemca}}</button> </li>
                        <li class="m-4"><span class="w-75 d-inline-block">Website </span><button (click)="retryWebsite()" class={{btnweb}}>{{btnvalueweb}}</button> </li>
                        <li class="m-4"><span class="w-75 d-inline-block"> Account </span><button class={{btnaccount}}>{{btnvalueaccount}}</button> </li>
                        <li class="m-4"><span class="w-75 d-inline-block">PEP, AML & Sanction Checks </span><button (click)="retryAml()" class={{btnaml}}>{{btnvalueaml}}</button> </li>
                    </ul>
                    <div  class="left-downlaod-btn">
                    <button *ngIf="this.permissions.includes('Download')" class="btn btn-primary btn-sm download mb-2" (click)="downloadAutomated()">Download</button>
                  </div>

                  <!-- <span *ngIf="showhtml" class="text-align" style="margin-left:44px; font-weight: bold;">KYC Details</span> -->
                  <!-- <div *ngFor="let doclist of rowData ">
                   <div class="row">
                             <div class="col-lg-12 col-sm-12">
                                 <div  class="h-100 p-2">
                                     <ul>
                                     <li class="m-4">                       
                                     <span class="w-75 d-inline-block">{{doclist.docType}}</span>                       
                                     <button (click)="onViewBtnClick(doclist.merchantId)" class="btn bg-danger-custom" type="button">
                                       <i class="feather icon-eye"></i>
                                   </button>
                                  
                                   </ul>                       
                               </div>
                           </div>
                        </div>
                  </div> -->
              </div>
            </div>
            <div class="vr p-1"></div>
              <div class="col-lg-6 col-sm-12">
                <span style="text-align: center;"><strong>Scanned Documents</strong></span>
                  <div  class="h-100">
                      <ul>
                          <li class="m-4"><span class="w-75 d-inline-block">PEP, AML & Sanction Checks </span><button class={{btnpep}}>{{btnvaluepep}}</button> </li>
                          <li class="m-4"><span class="w-75 d-inline-block">OSV Report </span><button class={{osvbtn}}>{{osvvalue}}</button> </li>
                          <li class="m-4"><span class="w-75 d-inline-block">Internal Audit Report </span><button class={{irabtn}}>{{iravalue}}</button> </li>
                          <li class="m-4"><span class="w-75 d-inline-block">Merchant Web Compliance </span><button class={{mcmTncBtn}}>{{mcmTncValue}}</button> </li>
                          <!-- <li class="m-4"><span class="w-75 d-inline-block"> Merchant's Grievance Policy </span><button class={{mcmMGPbtn}}>{{mcmMGPValue}}</button> </li> -->
                          <!-- <li class="m-4"><span class="w-75 d-inline-block">Merchant's Refund Policy </span><button class={{mcmMrpBtn}}>{{mcmMrpValue}}</button> </li>
                          <li class="m-4"><span class="w-75 d-inline-block">PCI-DSS AOC </span><button class={{mcmAOCbtn}}>{{mcmAOCValue}}</button> </li>
                          <li class="m-4"><span class="w-75 d-inline-block">PCI-DSS COC </span><button class={{mcmCOCBtn}}>{{mcmCOCValue}}</button> </li>
                          <li class="m-4"><span class="w-75 d-inline-block">Website VAPT Report</span> <button  class={{mcmVaptbtn}}>{{mcmVaptValue}}</button> </li> -->
                          <li class="m-4 visibility-hidden"><span class="w-75 d-inline-block">PCI-DSS COC </span><button class={{mcmCOCBtn}}>{{mcmCOCValue}}</button> </li>
                          <li class="m-4 visibility-hidden"><span class="w-75 d-inline-block">Website VAPT Report</span> <button  class={{mcmVaptbtn}}>{{mcmVaptValue}}</button> </li>
                      </ul>
                      <div  class="right-download-btn mt-2">
                        <button *ngIf="this.permissions.includes('Download')" class="btn btn-primary btn-sm" (click)="downloadManual()">Download</button>
                      </div>
                </div>
            </div>
         </div>
   </div>


  </div>
</div>